import { api } from './client';

/**
 * Расписание тренажёров: когда куратор открывает их своей группе.
 *
 * ⚠️ РАСПИСАНИЕ НЕ ДАЁТ ДОСТУПА, оно только сужает. Тренажёра нет в тарифе —
 * ученик не видит его нигде, и никакое расписание этого не изменит. Тренажёр
 * есть, но сегодня не его день — ученик видит, когда откроется.
 */
export type TrainerKind = 'speaking' | 'writing' | 'sprint' | 'mock';
export type ScheduleAudienceType = 'group' | 'marathon' | 'student';

export type TrainerScheduleRule = {
  id: string;
  trainer: TrainerKind;
  audience_type: ScheduleAudienceType;
  marathon_id?: string | null;
  group_id?: string | null;
  student_id?: string | null;
  /** 1 — понедельник … 7 — воскресенье. Пусто = любой день. */
  weekdays: number[];
  opens_on?: string | null;
  closes_on?: string | null;
  is_active: boolean;
};

/** Строка расписания глазами ученика: сервер уже посчитал «открыто сегодня». */
export type StudentTrainerSchedule = {
  trainer: TrainerKind;
  weekdays: number[];
  opens_on?: string | null;
  closes_on?: string | null;
  open_now: boolean;
  next_open?: string | null;
};

/**
 * Правило к отправке. У пробного экзамена дней недели нет (13.10.2026): поле
 * скрыто на экране, но дни, выбранные до переключения на мок, оставались в
 * черновике и уходили на сервер — и тот молча сужал окно экзамена до них.
 */
export function scheduleRuleForSave(rule: Partial<TrainerScheduleRule>): Partial<TrainerScheduleRule> {
  return rule.trainer === 'mock' ? { ...rule, weekdays: [] } : rule;
}

export const trainerScheduleApi = {
  list: () =>
    api.get<{ items: TrainerScheduleRule[] }>('/curator/trainer-schedule').then((r) => r.data?.items ?? []),
  create: (payload: Partial<TrainerScheduleRule>) =>
    api.post<TrainerScheduleRule>('/curator/trainer-schedule', payload).then((r) => r.data),
  update: (id: string, payload: Partial<TrainerScheduleRule>) =>
    api.put<TrainerScheduleRule>(`/curator/trainer-schedule/${id}`, payload).then((r) => r.data),
  remove: (id: string) => api.delete(`/curator/trainer-schedule/${id}`).then((r) => r.data),

  /** Расписание ученика — для календаря. */
  mine: () =>
    api
      .get<{ items: StudentTrainerSchedule[] }>('/student/trainer-schedule')
      .then((r) => r.data?.items ?? []),
};

/** Тренажёры, у которых бывает расписание. Порядок — как в интерфейсе. */
export const SCHEDULABLE_TRAINERS: TrainerKind[] = ['speaking', 'writing', 'sprint', 'mock'];
